<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <h4 class="page-title content__title">Lista usuarios</h4>
        </div>
        <div class="col-sm-6 col-sm-6 col-md-6 col-sm-6 col-6 content__boxBtnHead">
          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/empresa/usuarios/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Crear usuario </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light btn-sm" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
              <div class="content__subhead__inputGrid">
                <div class="input-group">
                  <span class="input-group-prepend"><span
                      class="input-group-text content__subhead__inputGrid__title">Estado</span></span>
                  <select class="form-control content__subhead__inputGrid__input" id="statusSelected"
                    [(ngModel)]="statusSelected" (change)="changeStatus()">
                    <option *ngFor="let item of status" [value]="item.status">{{ item.description }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>

          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Perfil</th>
                  <th>Empleado asignado</th>
                  <th>Usuario</th>
                  <th>Correo</th>
                  <th>Estado</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="2"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr [ngClass]="{'text-danger': item.deleted_at != null }"
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      <span class="bold">{{item.profile_description}}</span>
                      <div class="m-t-3 m-b-0 f-s-10" *ngIf="item.is_admin"><span class="badge badge-info">Admin Total</span></div>
                    </td>
                    <td>
                      <div *ngIf="item.employee_fullname == null">
                        <span>-</span>
                      </div>
                      <div *ngIf="item.employee_fullname != null">
                        <p class="m-b-0">{{item.employee_fullname}}</p>
                        <p class="bold f-s-10 m-b-0">{{item.typedocument}} : {{item.employee_document}}</p>
                      </div>
                    </td>
                    <td>{{item.username}}</td>
                    <td>{{item.email}}</td>
                    <td>
                      <span *ngIf="item.deleted_at == null" class="badge badge-success f-s-11">Activo</span>
                      <span *ngIf="item.deleted_at != null" class="badge badge-danger f-s-11">De baja</span>
                    </td>
                    <td class="text-center">
                      <div class="btn-group mo-mb-2" *ngIf="item.deleted_at == null">
                        <button class="btn btn-light btn-dots btn-sm dropdown-toggle" type="button"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fas fa-ellipsis-h"></i>
                        </button>
                        <div class="dropdown-menu" x-placement="bottom-start">
                          <a class="dropdown-item pointer" (click)="edit(item.id)">
                            <i class="far fa-edit m-r-5 text-success"></i>Editar
                          </a>
                          <a class="dropdown-item pointer" (click)="delete(item,i)">
                            <i class="far fa-trash-alt m-r-5 text-danger"></i>Dar de baja
                          </a>
                        </div>
                      </div>
                      <div class="btn-group mo-mb-2" *ngIf="item.deleted_at != null">
                        <button class="btn btn-light btn-dots btn-sm dropdown-toggle" type="button"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fas fa-ellipsis-h"></i>
                        </button>
                        <div class="dropdown-menu" x-placement="bottom-start">
                          <a class="dropdown-item pointer" (click)="activedUser(item)">
                            <i class="fas fa-check-circle m-r-5 text-success"></i>Activar usuario
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
